import React from 'react';
import Wrapper from './StyledPage';

export const Blog = () => {
  return <Wrapper>Blog</Wrapper>;
};
